const isDev = import.meta.env.DEV

export class Configs {
  static pageSize = 10
  static get commitSHA() {
    return import.meta.env.VITE_COMMIT_SHA
  }
  static get mainSubDomain() {
    return import.meta.env.VITE_MAIN_SUB_DOMAIN
  }
  static get isDev() {
    return isDev
  }

  static get socketUrl() {
    return replaceDomain(import.meta.env.VITE_MQTT_URL)
  }
  static get walletApiUrl() {
    return replaceDomain(import.meta.env.VITE_API_HUB_URL)
  }
  static get baseApiUrl() {
    return replaceDomain(import.meta.env.VITE_API_URL)
  }
  static get trackingId(): string {
    return import.meta.env.VITE_GA_TRACKING_ID || ''
  }
  static get graphApiUrl(): string {
    return import.meta.env.VITE_GRAPHQL_HTTP_URL || ''
  }
  static get plinkoGameId(): string {
    return import.meta.env.VITE_GAME_ID_PLINKO || ''
  }
  static get bingoGameId(): string {
    return import.meta.env.VITE_GAME_ID_BINGO || ''
  }
}

// input: https://hash-api.cryptogaming.top/api
// current origin: hash.devhost.cc
// output: https://hash-api.devhost.cc/api

// input: https://hash-api.cryptogaming.top/api
// current origin: unstable-hash.devhost.cc
// output: https://unstable-hash-api.devhost.cc/api

// input: https://hash-api.cryptogaming.top/api
// current origin: hash-unstable.devhost.cc
// output: https://hash-api-unstable.devhost.cc/api

export const replaceDomain = (url: string) => {
  if (isDev) return url
  const parentDomain = getParentDomain()
  const subDomain = getSubDomain(url)

  const domain = `${subDomain}.${parentDomain}`
  const parsedUrl = new URL(url)
  parsedUrl.hostname = domain
  return parsedUrl.toString()
}

function getParentDomain() {
  const hostname = window.location.hostname
  const paths = hostname.split('.')
  if (paths.length <= 2) return hostname
  paths.shift()
  return paths.join('.')
}
function getSubDomain(url: string) {
  const parsedUrl = new URL(url)
  const hostname = parsedUrl.hostname
  const paths = hostname.split('.')
  const _paths = location.hostname.split('.')
  if (_paths.length <= 2) return paths[0]
  return _paths[0].split(Configs.mainSubDomain).join(paths[0])
}
